import { __ANY_CTA } from 'customer-data-filters-ui/converters/listSegClassic/ListSegConstants';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'atom... Remove this comment to see the full error message
import { deref, unwatch, watch } from 'atom';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import { isResolved } from 'reference-resolvers/utils';
import FilterOperatorType from 'customer-data-filters-ui/components/propTypes/FilterOperatorType';
import I18n from 'I18n';
import PropTypes from 'prop-types';
import { Component } from 'react';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import ReferenceResolverType from 'reference-resolvers/schema/ReferenceResolverType';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import UISelect from 'UIComponents/input/UISelect';
import getIn from 'transmute/getIn';
import memoize from 'transmute/memoize';
import Raven from 'raven-js';
import { jsx as _jsx } from "react/jsx-runtime";
const ctaToOptions = memoize(ctaList => ctaList.map(cta => {
  const text = cta.get('label') ? cta.get('label') : I18n.text('customerDataFiltersUI.customerDataFilters.FilterEditor.specialOptionValues.variationCta.input', {
    variantLabel: cta.get('variantLabel')
  });
  return {
    value: cta.get('guid'),
    text: cta.get('isDefault') ? I18n.text('customerDataFiltersUI.customerDataFilters.FilterEditor.specialOptionValues.defaultCta.input') : text
  };
}).toArray());
class FilterOperatorCtaInput extends Component {
  constructor() {
    // @ts-expect-error ts-migrate(2554) FIXME: Expected 1-2 arguments, but got 0.
    super();
    this.handleChange = ({
      target: {
        value: nextValue
      }
    }) => {
      const {
        condition,
        fieldName,
        onChange
      } = this.props;
      onChange(syntheticEvent(condition.set(fieldName, nextValue)));
    };
    this.handleOptionsChange = cta => {
      if (isResolved(cta)) {
        const ctaInfo = cta.referencedObject.get('ctaInfo');
        const options = ctaInfo && ctaInfo.size > 0 ? ctaToOptions(ctaInfo) : [];
        this.setState({
          loading: false,
          options
        });
      }
    };
    this.state = {
      loading: true,
      options: []
    };
    this.referenceCtaAtom = null;
  }
  componentDidMount() {
    const {
      condition,
      fieldName,
      onChange,
      resolver
    } = this.props;
    const field = getIn(['field', 'name'], condition) || '';
    if (resolver && typeof resolver.byId !== 'function') {
      Raven.captureException(new Error(`[Expected a reference resolver] resolver does not have 'byId' function; condition.field: ${JSON.stringify(condition.field)}`));
    }
    if (resolver && resolver.byId && field) {
      this.referenceCtaAtom = resolver.byId(field);
      watch(this.referenceCtaAtom, this.handleOptionsChange);
      this.handleOptionsChange(deref(this.referenceCtaAtom));
    }
    onChange(syntheticEvent(condition.set(fieldName, condition.get(fieldName) || __ANY_CTA)));
  }
  componentWillUnmount() {
    if (this.referenceCtaAtom) {
      unwatch(this.referenceCtaAtom, this.handleOptionsChange);
    }
  }
  focus() {
    this.input.focus();
  }
  getOptions() {
    return [{
      text: I18n.text('customerDataFiltersUI.customerDataFilters.FilterEditor.specialOptionValues.anyCta.input'),
      value: __ANY_CTA
    }, ...this.state.options];
  }

  // @ts-expect-error ts-migrate(7031) FIXME: Binding element 'nextValue' implicitly has an 'any... Remove this comment to see the full error message

  render() {
    const {
      condition,
      fieldName,
      inputUse
    } = this.props;
    const {
      loading
    } = this.state;
    const error = loading ? false : undefined;
    return /*#__PURE__*/_jsx(UISelect, {
      buttonUse: inputUse === 'on-dark' ? 'form-on-dark' : undefined,
      defaultValue: __ANY_CTA,
      error: error,
      onChange: this.handleChange,
      options: this.getOptions(),
      ref: component => {
        this.input = component;
      }
      //@ts-expect-error `get` returns `unknown` type
      ,
      value: condition.get(fieldName)
    });
  }
}
FilterOperatorCtaInput.defaultProps = {
  fieldName: 'value'
};
FilterOperatorCtaInput.propTypes = {
  condition: FilterOperatorType.isRequired,
  fieldName: PropTypes.string.isRequired,
  inputUse: PropTypes.oneOf(['on-dark']),
  onChange: PropTypes.func.isRequired,
  resolver: ReferenceResolverType
};
export default FilterOperatorCtaInput;